(function(){
"use strict";

const MODES = {
  hexagon: {
    collections: ["hexagon-tiles"],
    tiers: [{paid:3,free:1},{paid:5,free:2},{paid:10,free:5},{paid:15,free:10},{paid:20,free:20},{paid:25,free:30}],
    shape: "hex",
    multB: 1.25,
    aspect: 0.85
  },
  framed: {
    collections: ["framed-displays-pokemon", "framed-displays-one-piece"],
    tiers: [{paid:3,free:1},{paid:5,free:2},{paid:10,free:5}],
    shape: "rect",
    multB: 1,
    aspect: 1.22
  }
};

const FAQ_ITEMS_EN = [
  {q:"How does the Wall Builder work?", a:"<p>Browse the designs on the left, click \"+ Add\" to add them to your wall, and drag them around to arrange your layout exactly how you like it.</p>"},
  {q:"Are the trading cards or slabs included?", a:"<p>No. The trading card and card holder (such as a UV Mini Snap or graded slab) are not included. Each display comes with a precisely sized placeholder that matches the dimensions of the card. This serves as a guide, making it easy to position your card exactly where it belongs for a perfect fit.</p>"},
  {q:"Do the displays include UV protection?", a:"<p>The display itself does not include UV-protective acrylic. For maximum protection we recommend:</p><ul><li><strong>Ungraded cards:</strong> Ultra PRO UV Mini Snap</li><li><strong>Graded cards:</strong> A UV-protective outer sleeve or case if displayed in direct sunlight</li></ul><p>We also recommend avoiding prolonged direct sunlight whenever possible.</p>"},
  {q:"What's the difference between Small and Large Hexagons?", a:"<p>Each design is available in two sizes. Use the Size toggle to choose which one gets added when you click \"+ Add\" — you can also switch an individual display's size afterwards by clicking its size badge on the wall.</p><p>The hexagon displays are available in two sizes:</p><p><strong>Europe &amp; UK</strong></p><ul><li>Small: 20 × 17 cm</li><li>Large: 25 × 21 cm</li></ul><p><strong>International (USA, Canada &amp; Rest of World)</strong></p><ul><li>Small: 7 × 6\" (18 × 15 cm)</li><li>Large: 9 × 8\" (23 × 20 cm)</li></ul><p>The Small display is designed for standard trading cards, while the Large display is designed for graded cards such as PSA, Beckett (BGS), and CGC. The Large display can also be used for ungraded cards if you prefer a bigger presentation.</p>"},
  {q:"How do the free displays work?", a:"<p>The more displays you add, the more you unlock for free — buy 3 get 1 free, buy 5 get 2 free, and so on. Once you reach a tier, choose your free display(s) from the catalog and they'll be marked FREE automatically.</p>"},
  {q:"Is the discount applied automatically?", a:"<p>Yes. There's no coupon needed — the discount is applied automatically in your cart based on how many displays you've added. You can also apply an additional promo code during checkout if you have one. Your bundle discount will remain applied, and any eligible coupon discount will be added automatically.</p>"},
  {q:"Can I combine Hexagons and Frames?", a:"<p>Each wall uses one catalog at a time. Switching between Hexagons and Frames will clear your current wall, so build and add one style to your cart before switching to the other.</p>"},
  {q:"Can I still change my wall after adding it to the cart?", a:"<p>Yes — from your cart you can remove items or come back to the Wall Builder to add more before checking out.</p>"},
  {q:"Can I request a card that isn't available yet?", a:"<p>Absolutely! If you can't find your desired card design, simply use our Request a Design page. We'll create it for you and notify you as soon as it's ready. Current turnaround: 2–4 weeks.</p>"},
  {q:"What are the displays made from?", a:"<p>To provide faster delivery, lower shipping costs, and avoid unnecessary import fees, we produce and ship orders from two regional production hubs: one serving Europe and one serving international customers. Because of this, the materials vary slightly by region while maintaining the same premium quality and appearance.</p><p><strong>US / CA / AUS</strong></p><ul><li>Premium acrylic display</li><li>Lightweight construction</li><li>High-resolution print</li><li>Designed for easy wall mounting</li></ul><p><strong>Europe &amp; UK</strong></p><ul><li>Premium aluminum composite panel</li><li>Matte professional finish</li><li>Lightweight yet rigid</li><li>High-resolution UV print</li></ul><p>Regardless of production location, every display is made using premium materials and color-calibrated printing.</p>"},
  {q:"How do I mount the displays?", a:"<p>Mounting methods depend on your region.</p><p><strong>USA, Canada &amp; Australia — Card mounting</strong></p><ul><li>Card mounting accessories are not included with international orders, giving you the flexibility to use your preferred holder and mounting method.</li><li>We recommend using an Ultra PRO UV Mini Snap for standard cards or a UV-protective outer case for slabs.</li><li>To attach the holder to the display, we recommend using strong double-sided adhesive pads, 3M VHB mounting tape, or another high-quality removable adhesive solution of your choice.</li><li>Tip for graded slabs: to help prevent adhesive residue, first apply a small piece of transparent tape to the back of your slab, then attach the adhesive pad to the tape rather than directly to the slab.</li></ul><p><strong>USA, Canada &amp; Australia — Wall mounting</strong></p><ul><li>Each display comes with pre-applied adhesive mounting strips on the back.</li><li>Simply remove the brown front protective layer and press the display firmly onto a clean, smooth wall.</li></ul><p><strong>Europe &amp; UK — Card mounting</strong></p><ul><li>The card holder is attached using the included self-adhesive magnets.</li><li>We recommend using an Ultra PRO UV Mini Snap for standard cards or a UV-protective outer case for slabs.</li><li>Attach the magnetic mount to the marked placement area on the display, then attach the other side to your card holder or slab.</li><li>Press firmly on both sides and double check it's applied correctly.</li></ul><p><strong>Europe &amp; UK — Wall mounting</strong></p><ul><li>Each display includes 2 self-adhesive magnetic mounting plates.</li><li>Attach one side of the magnetic plate to the back of your display and the other side to a clean wall, pressing firmly on both sides.</li><li>Simply place the display onto the magnet — this lets you remove or reposition it whenever needed.</li></ul>"},
  {q:"Will the adhesive damage my wall?", a:"<p>Removal depends on your wall surface and paint condition. We always recommend removing the adhesive using slow and careful twisting motions.</p>"}
];

const FAQ_ITEMS_NL = [
  {q:"Hoe werkt de Wall Builder?", a:"<p>Blader door de designs aan de linkerkant, klik op \"+ Toevoegen\" om ze aan je muur toe te voegen, en sleep ze rond om je indeling precies zo te maken als jij wilt.</p>"},
  {q:"Zijn de trading cards of slabs inbegrepen?", a:"<p>Nee. De trading card en cardholder (zoals een UV Mini Snap of graded slab) zijn niet inbegrepen. Elke display wordt geleverd met een nauwkeurig passende placeholder die overeenkomt met de afmetingen van de kaart. Dit dient als richtlijn, zodat je jouw kaart precies op de juiste plek kunt positioneren voor een perfecte pasvorm.</p>"},
  {q:"Bieden de displays UV-bescherming?", a:"<p>De display zelf bevat geen UV-beschermend acryl. Voor maximale bescherming raden we aan:</p><ul><li><strong>Ongraded kaarten:</strong> Ultra PRO UV Mini Snap</li><li><strong>Graded kaarten:</strong> Een UV-beschermende buitenhoes of case bij weergave in direct zonlicht</li></ul><p>We raden ook aan om langdurig direct zonlicht zoveel mogelijk te vermijden.</p>"},
  {q:"Wat is het verschil tussen Small en Large Hexagons?", a:"<p>Elk design is verkrijgbaar in twee formaten. Gebruik de formaat-toggle om te kiezen welk formaat wordt toegevoegd wanneer je op \"+ Toevoegen\" klikt — je kunt het formaat van een individuele display achteraf ook wijzigen door op het formaatlabel op de muur te klikken.</p><p>De hexagon displays zijn verkrijgbaar in twee formaten:</p><p><strong>Europa &amp; UK</strong></p><ul><li>Small: 20 × 17 cm</li><li>Large: 25 × 21 cm</li></ul><p><strong>Internationaal (VS, Canada &amp; Rest van de Wereld)</strong></p><ul><li>Small: 7 × 6\" (18 × 15 cm)</li><li>Large: 9 × 8\" (23 × 20 cm)</li></ul><p>De Small display is bedoeld voor standaard trading cards, terwijl de Large display is bedoeld voor graded kaarten zoals PSA, Beckett (BGS) en CGC. De Large display kan ook worden gebruikt voor ongraded kaarten als je een grotere presentatie wilt.</p>"},
  {q:"Hoe werken de gratis displays?", a:"<p>Hoe meer displays je toevoegt, hoe meer je gratis ontgrendelt — koop 3 krijg 1 gratis, koop 5 krijg 2 gratis, enzovoort. Zodra je een staffel bereikt, kies je jouw gratis display(s) uit de catalogus en worden ze automatisch gemarkeerd als GRATIS.</p>"},
  {q:"Wordt de korting automatisch toegepast?", a:"<p>Ja. Er is geen kortingscode nodig — de korting wordt automatisch toegepast in je winkelmandje op basis van het aantal displays dat je hebt toegevoegd. Je kunt tijdens het afrekenen ook een extra kortingscode toepassen als je die hebt. Je staffelkorting blijft van toepassing en een eventuele geldige couponkorting wordt automatisch toegevoegd.</p>"},
  {q:"Kan ik Hexagons en Frames combineren?", a:"<p>Elke muur gebruikt één catalogus tegelijk. Wisselen tussen Hexagons en Frames leegt je huidige muur, dus bouw en voeg één stijl toe aan je winkelmandje voordat je overschakelt naar de andere.</p>"},
  {q:"Kan ik mijn muur nog aanpassen nadat ik hem aan het winkelmandje heb toegevoegd?", a:"<p>Ja — vanuit je winkelmandje kun je items verwijderen of terugkeren naar de Wall Builder om meer toe te voegen voordat je afrekent.</p>"},
  {q:"Kan ik een kaart aanvragen die nog niet beschikbaar is?", a:"<p>Zeker! Als je het gewenste kaartdesign niet kunt vinden, gebruik dan gewoon onze pagina Ontwerp Aanvragen. Wij maken het voor je en laten het je weten zodra het klaar is. Huidige doorlooptijd: 2–4 weken.</p>"},
  {q:"Waar zijn de displays van gemaakt?", a:"<p>Om snellere levering, lagere verzendkosten en onnodige invoerkosten te voorkomen, produceren en verzenden we bestellingen vanuit twee regionale productiehubs: één voor Europa en één voor internationale klanten. Hierdoor variëren de materialen enigszins per regio, terwijl dezelfde premium kwaliteit en uitstraling behouden blijft.</p><p><strong>VS / Canada / Australië</strong></p><ul><li>Premium acryl display</li><li>Lichtgewicht constructie</li><li>Hoge-resolutie print</li><li>Ontworpen voor eenvoudige wandmontage</li></ul><p><strong>Europa &amp; UK</strong></p><ul><li>Premium aluminium composietpaneel</li><li>Matte professionele afwerking</li><li>Lichtgewicht maar stevig</li><li>Hoge-resolutie UV-print</li></ul><p>Ongeacht de productielocatie wordt elke display gemaakt met premium materialen en kleurgekalibreerd printen.</p>"},
  {q:"Hoe monteer ik de displays?", a:"<p>De montagemethode is afhankelijk van jouw regio.</p><p><strong>VS, Canada &amp; Australië — Kaartmontage</strong></p><ul><li>Montageaccessoires voor de kaart zijn niet inbegrepen bij internationale bestellingen, zodat je flexibel bent in je gewenste houder en montagemethode.</li><li>We raden een Ultra PRO UV Mini Snap aan voor standaard kaarten of een UV-beschermende buitenhoes voor slabs.</li><li>Om de houder aan de display te bevestigen, raden we sterke dubbelzijdige plakstrips, 3M VHB montagetape of een andere hoogwaardige verwijderbare kleefoplossing naar keuze aan.</li><li>Tip voor graded slabs: om lijmresten te voorkomen, plak eerst een klein stukje transparante tape op de achterkant van je slab en bevestig de plakstrip vervolgens aan de tape in plaats van rechtstreeks aan de slab.</li></ul><p><strong>VS, Canada &amp; Australië — Wandmontage</strong></p><ul><li>Elke display wordt geleverd met voorgeplakte kleefstrips op de achterkant.</li><li>Verwijder simpelweg de bruine beschermlaag aan de voorkant en druk de display stevig op een schone, gladde muur.</li></ul><p><strong>Europa &amp; UK — Kaartmontage</strong></p><ul><li>De cardholder wordt bevestigd met de meegeleverde zelfklevende magneten.</li><li>We raden een Ultra PRO UV Mini Snap aan voor standaard kaarten of een UV-beschermende buitenhoes voor slabs.</li><li>Bevestig de magnetische mount op de gemarkeerde plek op de display en bevestig de andere kant aan je cardholder of slab.</li><li>Druk stevig op beide kanten en controleer of alles goed vastzit.</li></ul><p><strong>Europa &amp; UK — Wandmontage</strong></p><ul><li>Elke display bevat 2 zelfklevende magnetische montageplaatjes.</li><li>Bevestig één kant van het magnetische plaatje aan de achterkant van je display en de andere kant aan een schone muur, en druk stevig op beide kanten.</li><li>Plaats de display simpelweg op de magneet — zo kun je hem altijd verwijderen of verplaatsen wanneer je maar wilt.</li></ul>"},
  {q:"Beschadigt de lijm mijn muur?", a:"<p>Dit hangt af van je wandoppervlak en de staat van de verf. We raden altijd aan om de lijm te verwijderen met langzame, voorzichtige draaibewegingen.</p>"}
];

const FAQ_ITEMS_DE = [
  {q:"Wie funktioniert der Wall Builder?", a:"<p>Durchstöbere die Designs auf der linken Seite, klicke auf \"+ Hinzufügen\", um sie zu deiner Wand hinzuzufügen, und ziehe sie herum, um dein Layout genau so zu gestalten, wie du es möchtest.</p>"},
  {q:"Sind die Trading Cards oder Slabs enthalten?", a:"<p>Nein. Die Trading Card und der Kartenhalter (z. B. ein UV Mini Snap oder ein Grading-Slab) sind nicht enthalten. Jedes Display wird mit einem präzise angepassten Platzhalter geliefert, der den Maßen der Karte entspricht. Dies dient als Orientierungshilfe, damit du deine Karte genau richtig positionieren kannst, für eine perfekte Passform.</p>"},
  {q:"Bieten die Displays UV-Schutz?", a:"<p>Das Display selbst enthält kein UV-schützendes Acryl. Für maximalen Schutz empfehlen wir:</p><ul><li><strong>Ungraded Karten:</strong> Ultra PRO UV Mini Snap</li><li><strong>Graded Karten:</strong> Eine UV-schützende Außenhülle oder ein Case, falls in direktem Sonnenlicht ausgestellt</li></ul><p>Wir empfehlen außerdem, längere direkte Sonneneinstrahlung möglichst zu vermeiden.</p>"},
  {q:"Was ist der Unterschied zwischen Small und Large Hexagons?", a:"<p>Jedes Design ist in zwei Größen erhältlich. Verwende den Größen-Umschalter, um festzulegen, welche Größe beim Klick auf \"+ Hinzufügen\" hinzugefügt wird — du kannst die Größe eines einzelnen Displays auch nachträglich ändern, indem du auf das Größenabzeichen an der Wand klickst.</p><p>Die Hexagon-Displays sind in zwei Größen erhältlich:</p><p><strong>Europa &amp; UK</strong></p><ul><li>Small: 20 × 17 cm</li><li>Large: 25 × 21 cm</li></ul><p><strong>International (USA, Kanada &amp; Rest der Welt)</strong></p><ul><li>Small: 7 × 6\" (18 × 15 cm)</li><li>Large: 9 × 8\" (23 × 20 cm)</li></ul><p>Das Small-Display ist für Standard-Trading-Cards konzipiert, während das Large-Display für graded Karten wie PSA, Beckett (BGS) und CGC gedacht ist. Das Large-Display kann auch für ungraded Karten verwendet werden, wenn du eine größere Präsentation bevorzugst.</p>"},
  {q:"Wie funktionieren die gratis Displays?", a:"<p>Je mehr Displays du hinzufügst, desto mehr schaltest du gratis frei — kaufe 3, erhalte 1 gratis, kaufe 5, erhalte 2 gratis, und so weiter. Sobald du eine Stufe erreichst, wählst du deine gratis Display(s) aus dem Katalog aus und sie werden automatisch als GRATIS markiert.</p>"},
  {q:"Wird der Rabatt automatisch angewendet?", a:"<p>Ja. Es ist kein Gutscheincode nötig — der Rabatt wird automatisch in deinem Warenkorb angewendet, basierend darauf, wie viele Displays du hinzugefügt hast. Du kannst beim Checkout zusätzlich einen weiteren Rabattcode anwenden, falls du einen hast. Dein Mengenrabatt bleibt bestehen, und ein gültiger Gutscheinrabatt wird automatisch hinzugefügt.</p>"},
  {q:"Kann ich Hexagons und Rahmen kombinieren?", a:"<p>Jede Wand verwendet jeweils einen Katalog. Der Wechsel zwischen Hexagons und Rahmen leert deine aktuelle Wand, also baue und füge einen Stil zu deinem Warenkorb hinzu, bevor du zum anderen wechselst.</p>"},
  {q:"Kann ich meine Wand noch ändern, nachdem ich sie zum Warenkorb hinzugefügt habe?", a:"<p>Ja — von deinem Warenkorb aus kannst du Artikel entfernen oder zum Wall Builder zurückkehren, um vor dem Checkout weitere hinzuzufügen.</p>"},
  {q:"Kann ich eine Karte anfragen, die noch nicht verfügbar ist?", a:"<p>Auf jeden Fall! Wenn du dein gewünschtes Kartendesign nicht findest, nutze einfach unsere Seite Design anfragen. Wir erstellen es für dich und benachrichtigen dich, sobald es fertig ist. Aktuelle Bearbeitungszeit: 2–4 Wochen.</p>"},
  {q:"Aus welchem Material bestehen die Displays?", a:"<p>Um schnellere Lieferzeiten, geringere Versandkosten und unnötige Einfuhrgebühren zu vermeiden, produzieren und versenden wir Bestellungen aus zwei regionalen Produktionszentren: eines für Europa und eines für internationale Kunden. Dadurch variieren die Materialien je nach Region leicht, während die gleiche Premium-Qualität und Optik erhalten bleibt.</p><p><strong>USA / Kanada / Australien</strong></p><ul><li>Premium-Acryl-Display</li><li>Leichte Konstruktion</li><li>Hochauflösender Druck</li><li>Für einfache Wandmontage konzipiert</li></ul><p><strong>Europa &amp; UK</strong></p><ul><li>Premium-Aluminiumverbundplatte</li><li>Matte, professionelle Oberfläche</li><li>Leicht, aber stabil</li><li>Hochauflösender UV-Druck</li></ul><p>Unabhängig vom Produktionsstandort wird jedes Display mit hochwertigen Materialien und farbkalibriertem Druck hergestellt.</p>"},
  {q:"Wie montiere ich die Displays?", a:"<p>Die Montagemethode hängt von deiner Region ab.</p><p><strong>USA, Kanada &amp; Australien — Kartenmontage</strong></p><ul><li>Montagezubehör für die Karte ist bei internationalen Bestellungen nicht enthalten, damit du flexibel deinen bevorzugten Halter und deine Montagemethode wählen kannst.</li><li>Wir empfehlen einen Ultra PRO UV Mini Snap für Standardkarten oder eine UV-schützende Außenhülle für Slabs.</li><li>Um den Halter am Display zu befestigen, empfehlen wir starke doppelseitige Klebepads, 3M VHB Montageband oder eine andere hochwertige, entfernbare Klebelösung deiner Wahl.</li><li>Tipp für graded Slabs: Um Kleberückstände zu vermeiden, klebe zuerst ein kleines Stück transparentes Klebeband auf die Rückseite deines Slabs und befestige das Klebepad dann am Klebeband statt direkt am Slab.</li></ul><p><strong>USA, Kanada &amp; Australien — Wandmontage</strong></p><ul><li>Jedes Display wird mit bereits aufgebrachten Klebestreifen auf der Rückseite geliefert.</li><li>Entferne einfach die braune Schutzfolie auf der Vorderseite und drücke das Display fest auf eine saubere, glatte Wand.</li></ul><p><strong>Europa &amp; UK — Kartenmontage</strong></p><ul><li>Der Kartenhalter wird mit den mitgelieferten selbstklebenden Magneten befestigt.</li><li>Wir empfehlen einen Ultra PRO UV Mini Snap für Standardkarten oder eine UV-schützende Außenhülle für Slabs.</li><li>Befestige die Magnethalterung an der markierten Stelle auf dem Display und dann die andere Seite an deinem Kartenhalter oder Slab.</li><li>Drücke fest auf beide Seiten und prüfe, ob alles richtig sitzt.</li></ul><p><strong>Europa &amp; UK — Wandmontage</strong></p><ul><li>Jedes Display enthält 2 selbstklebende Magnetmontageplatten.</li><li>Befestige eine Seite der Magnetplatte an der Rückseite deines Displays und die andere Seite an einer sauberen Wand, wobei du auf beiden Seiten fest andrückst.</li><li>Platziere das Display einfach auf dem Magneten — so kannst du es jederzeit entfernen oder neu positionieren.</li></ul>"},
  {q:"Beschädigt der Kleber meine Wand?", a:"<p>Das hängt von deiner Wandoberfläche und dem Zustand der Farbe ab. Wir empfehlen immer, den Kleber mit langsamen, vorsichtigen Drehbewegungen zu entfernen.</p>"}
];

const FAQ_ITEMS_ES = [
  {q:"¿Cómo funciona el Wall Builder?", a:"<p>Explora los diseños de la izquierda, haz clic en \"+ Añadir\" para agregarlos a tu pared, y arrástralos para organizar tu diseño exactamente como quieras.</p>"},
  {q:"¿Están incluidas las cartas o los slabs?", a:"<p>No. La carta y el soporte para cartas (como un UV Mini Snap o un slab gradeado) no están incluidos. Cada display incluye un marcador de posición con el tamaño exacto que coincide con las dimensiones de la carta. Esto sirve como guía, facilitando colocar tu carta exactamente donde corresponde para un ajuste perfecto.</p>"},
  {q:"¿Los displays incluyen protección UV?", a:"<p>El display en sí no incluye acrílico con protección UV. Para máxima protección recomendamos:</p><ul><li><strong>Cartas sin gradear:</strong> Ultra PRO UV Mini Snap</li><li><strong>Cartas gradeadas:</strong> Una funda exterior o estuche con protección UV si se exhiben bajo luz solar directa</li></ul><p>También recomendamos evitar la exposición prolongada a la luz solar directa siempre que sea posible.</p>"},
  {q:"¿Cuál es la diferencia entre los Hexágonos Small y Large?", a:"<p>Cada diseño está disponible en dos tamaños. Usa el selector de tamaño para elegir cuál se añade al hacer clic en \"+ Añadir\" — también puedes cambiar el tamaño de un display individual más adelante haciendo clic en su etiqueta de tamaño en la pared.</p><p>Los displays hexagonales están disponibles en dos tamaños:</p><p><strong>Europa y Reino Unido</strong></p><ul><li>Small: 20 × 17 cm</li><li>Large: 25 × 21 cm</li></ul><p><strong>Internacional (EE. UU., Canadá y resto del mundo)</strong></p><ul><li>Small: 7 × 6\" (18 × 15 cm)</li><li>Large: 9 × 8\" (23 × 20 cm)</li></ul><p>El display Small está diseñado para cartas estándar, mientras que el Large está pensado para cartas gradeadas como PSA, Beckett (BGS) y CGC. El display Large también se puede usar para cartas sin gradear si prefieres una presentación más grande.</p>"},
  {q:"¿Cómo funcionan los displays gratis?", a:"<p>Cuantos más displays añadas, más desbloqueas gratis — compra 3 y llévate 1 gratis, compra 5 y llévate 2 gratis, y así sucesivamente. Al alcanzar un nivel, elige tus displays gratis del catálogo y se marcarán automáticamente como GRATIS.</p>"},
  {q:"¿El descuento se aplica automáticamente?", a:"<p>Sí. No necesitas ningún cupón — el descuento se aplica automáticamente en tu carrito según la cantidad de displays que hayas añadido. También puedes aplicar un código promocional adicional durante el checkout si tienes uno. Tu descuento por volumen seguirá aplicado, y cualquier descuento de cupón válido se añadirá automáticamente.</p>"},
  {q:"¿Puedo combinar Hexágonos y Marcos?", a:"<p>Cada pared utiliza un catálogo a la vez. Cambiar entre Hexágonos y Marcos vaciará tu pared actual, así que construye y añade un estilo a tu carrito antes de cambiar al otro.</p>"},
  {q:"¿Puedo seguir modificando mi pared después de añadirla al carrito?", a:"<p>Sí — desde tu carrito puedes eliminar artículos o volver al Wall Builder para añadir más antes de finalizar la compra.</p>"},
  {q:"¿Puedo solicitar una carta que aún no está disponible?", a:"<p>¡Por supuesto! Si no encuentras el diseño de carta que buscas, simplemente utiliza nuestra página Solicitar un Diseño. Lo crearemos para ti y te avisaremos en cuanto esté listo. Plazo actual: 2–4 semanas.</p>"},
  {q:"¿De qué están hechos los displays?", a:"<p>Para ofrecer entregas más rápidas, reducir los costes de envío y evitar tarifas de importación innecesarias, producimos y enviamos los pedidos desde dos centros de producción regionales: uno que atiende a Europa y otro a clientes internacionales. Por ello, los materiales varían ligeramente según la región, manteniendo la misma calidad y apariencia premium.</p><p><strong>EE. UU. / Canadá / Australia</strong></p><ul><li>Display de acrílico premium</li><li>Construcción ligera</li><li>Impresión de alta resolución</li><li>Diseñado para un montaje en pared sencillo</li></ul><p><strong>Europa y Reino Unido</strong></p><ul><li>Panel compuesto de aluminio premium</li><li>Acabado mate profesional</li><li>Ligero pero rígido</li><li>Impresión UV de alta resolución</li></ul><p>Independientemente del lugar de producción, cada display se fabrica con materiales premium e impresión calibrada en color.</p>"},
  {q:"¿Cómo monto los displays?", a:"<p>El método de montaje depende de tu región.</p><p><strong>EE. UU., Canadá y Australia — Montaje de la carta</strong></p><ul><li>Los accesorios de montaje de la carta no están incluidos en los pedidos internacionales, lo que te da la flexibilidad de usar el soporte y método de montaje que prefieras.</li><li>Recomendamos usar un Ultra PRO UV Mini Snap para cartas estándar o un estuche exterior con protección UV para slabs.</li><li>Para fijar el soporte al display, recomendamos usar almohadillas adhesivas de doble cara resistentes, cinta de montaje 3M VHB, u otra solución adhesiva removible de alta calidad de tu elección.</li><li>Consejo para slabs gradeados: para evitar residuos de adhesivo, coloca primero un pequeño trozo de cinta transparente en la parte trasera de tu slab y luego pega la almohadilla adhesiva sobre la cinta en lugar de directamente sobre el slab.</li></ul><p><strong>EE. UU., Canadá y Australia — Montaje en la pared</strong></p><ul><li>Cada display incluye tiras adhesivas de montaje preaplicadas en la parte trasera.</li><li>Simplemente retira la capa protectora frontal marrón y presiona el display firmemente contra una pared limpia y lisa.</li></ul><p><strong>Europa y Reino Unido — Montaje de la carta</strong></p><ul><li>El soporte para la carta se fija con los imanes autoadhesivos incluidos.</li><li>Recomendamos usar un Ultra PRO UV Mini Snap para cartas estándar o un estuche exterior con protección UV para slabs.</li><li>Fija el imán en el área marcada del display y luego el otro lado en tu soporte para carta o slab.</li><li>Presiona firmemente ambos lados y comprueba que esté bien colocado.</li></ul><p><strong>Europa y Reino Unido — Montaje en la pared</strong></p><ul><li>Cada display incluye 2 placas magnéticas autoadhesivas de montaje.</li><li>Fija un lado de la placa magnética a la parte trasera de tu display y el otro lado a una pared limpia, presionando firmemente ambos lados.</li><li>Simplemente coloca el display sobre el imán — esto te permite retirarlo o reposicionarlo cuando lo necesites.</li></ul>"},
  {q:"¿El adhesivo dañará mi pared?", a:"<p>Depende de la superficie de tu pared y el estado de la pintura. Siempre recomendamos retirar el adhesivo con movimientos de giro lentos y cuidadosos.</p>"}
];

const FAQ_ITEMS_FR = [
  {q:"Comment fonctionne le Wall Builder ?", a:"<p>Parcourez les designs à gauche, cliquez sur \"+ Ajouter\" pour les ajouter à votre mur, et faites-les glisser pour organiser votre agencement exactement comme vous le souhaitez.</p>"},
  {q:"Les cartes ou les slabs sont-ils inclus ?", a:"<p>Non. La carte à jouer et son support (comme un UV Mini Snap ou un slab gradé) ne sont pas inclus. Chaque display est livré avec un emplacement précisément dimensionné qui correspond aux dimensions de la carte. Cela sert de guide, facilitant le positionnement exact de votre carte pour un ajustement parfait.</p>"},
  {q:"Les displays incluent-ils une protection UV ?", a:"<p>Le display lui-même n'inclut pas d'acrylique à protection UV. Pour une protection maximale, nous recommandons :</p><ul><li><strong>Cartes non gradées :</strong> Ultra PRO UV Mini Snap</li><li><strong>Cartes gradées :</strong> Une pochette extérieure ou un étui à protection UV si exposé à la lumière directe du soleil</li></ul><p>Nous recommandons également d'éviter autant que possible une exposition prolongée à la lumière directe du soleil.</p>"},
  {q:"Quelle est la différence entre les Hexagones Small et Large ?", a:"<p>Chaque design est disponible en deux tailles. Utilisez le sélecteur de taille pour choisir celle qui sera ajoutée lorsque vous cliquez sur \"+ Ajouter\" — vous pouvez également modifier la taille d'un display individuel par la suite en cliquant sur son badge de taille sur le mur.</p><p>Les displays hexagonaux sont disponibles en deux tailles :</p><p><strong>Europe &amp; Royaume-Uni</strong></p><ul><li>Small : 20 × 17 cm</li><li>Large : 25 × 21 cm</li></ul><p><strong>International (États-Unis, Canada &amp; reste du monde)</strong></p><ul><li>Small : 7 × 6\" (18 × 15 cm)</li><li>Large : 9 × 8\" (23 × 20 cm)</li></ul><p>Le display Small est conçu pour les cartes standard, tandis que le display Large est conçu pour les cartes gradées telles que PSA, Beckett (BGS) et CGC. Le display Large peut également être utilisé pour des cartes non gradées si vous préférez une présentation plus grande.</p>"},
  {q:"Comment fonctionnent les displays gratuits ?", a:"<p>Plus vous ajoutez de displays, plus vous en débloquez gratuitement — achetez-en 3, obtenez-en 1 gratuit, achetez-en 5, obtenez-en 2 gratuits, et ainsi de suite. Une fois un palier atteint, choisissez vos displays gratuits dans le catalogue et ils seront automatiquement marqués GRATUIT.</p>"},
  {q:"La remise est-elle appliquée automatiquement ?", a:"<p>Oui. Aucun code n'est nécessaire — la remise est appliquée automatiquement dans votre panier en fonction du nombre de displays que vous avez ajoutés. Vous pouvez également appliquer un code promo supplémentaire lors du paiement si vous en avez un. Votre remise par palier restera appliquée, et toute remise de coupon éligible sera ajoutée automatiquement.</p>"},
  {q:"Puis-je combiner Hexagones et Cadres ?", a:"<p>Chaque mur utilise un seul catalogue à la fois. Passer des Hexagones aux Cadres videra votre mur actuel, alors construisez et ajoutez un style à votre panier avant de passer à l'autre.</p>"},
  {q:"Puis-je encore modifier mon mur après l'avoir ajouté au panier ?", a:"<p>Oui — depuis votre panier, vous pouvez retirer des articles ou revenir au Wall Builder pour en ajouter d'autres avant de finaliser votre commande.</p>"},
  {q:"Puis-je demander une carte qui n'est pas encore disponible ?", a:"<p>Absolument ! Si vous ne trouvez pas le design de carte souhaité, utilisez simplement notre page Demander un Design. Nous le créerons pour vous et vous informerons dès qu'il sera prêt. Délai actuel : 2 à 4 semaines.</p>"},
  {q:"En quoi sont fabriqués les displays ?", a:"<p>Pour offrir une livraison plus rapide, des frais de port réduits et éviter des frais d'importation inutiles, nous produisons et expédions les commandes depuis deux centres de production régionaux : l'un pour l'Europe et l'autre pour les clients internationaux. Les matériaux varient donc légèrement selon la région, tout en conservant la même qualité et apparence premium.</p><p><strong>États-Unis / Canada / Australie</strong></p><ul><li>Display en acrylique premium</li><li>Construction légère</li><li>Impression haute résolution</li><li>Conçu pour un montage mural facile</li></ul><p><strong>Europe &amp; Royaume-Uni</strong></p><ul><li>Panneau composite en aluminium premium</li><li>Finition mate professionnelle</li><li>Léger mais rigide</li><li>Impression UV haute résolution</li></ul><p>Quel que soit le lieu de production, chaque display est fabriqué avec des matériaux premium et une impression calibrée en couleur.</p>"},
  {q:"Comment fixer les displays ?", a:"<p>La méthode de fixation dépend de votre région.</p><p><strong>États-Unis, Canada &amp; Australie — Fixation de la carte</strong></p><ul><li>Les accessoires de fixation de la carte ne sont pas inclus dans les commandes internationales, ce qui vous permet de choisir librement votre support et méthode de fixation préférés.</li><li>Nous recommandons un Ultra PRO UV Mini Snap pour les cartes standard ou un étui extérieur à protection UV pour les slabs.</li><li>Pour fixer le support au display, nous recommandons des pastilles adhésives double face résistantes, du ruban de montage 3M VHB, ou une autre solution adhésive amovible de haute qualité de votre choix.</li><li>Astuce pour les slabs gradés : pour éviter les résidus de colle, appliquez d'abord un petit morceau de ruban transparent à l'arrière de votre slab, puis fixez la pastille adhésive sur le ruban plutôt que directement sur le slab.</li></ul><p><strong>États-Unis, Canada &amp; Australie — Montage mural</strong></p><ul><li>Chaque display est livré avec des bandes adhésives de montage pré-appliquées à l'arrière.</li><li>Retirez simplement la couche protectrice brune à l'avant et appuyez fermement le display sur un mur propre et lisse.</li></ul><p><strong>Europe &amp; Royaume-Uni — Fixation de la carte</strong></p><ul><li>Le support de carte se fixe à l'aide des aimants autocollants inclus.</li><li>Nous recommandons un Ultra PRO UV Mini Snap pour les cartes standard ou un étui extérieur à protection UV pour les slabs.</li><li>Fixez le support magnétique à l'emplacement marqué sur le display, puis fixez l'autre côté à votre support de carte ou slab.</li><li>Appuyez fermement des deux côtés et vérifiez que tout est correctement fixé.</li></ul><p><strong>Europe &amp; Royaume-Uni — Montage mural</strong></p><ul><li>Chaque display comprend 2 plaques de montage magnétiques autocollantes.</li><li>Fixez un côté de la plaque magnétique à l'arrière de votre display et l'autre côté à un mur propre, en appuyant fermement des deux côtés.</li><li>Placez simplement le display sur l'aimant — cela vous permet de le retirer ou de le repositionner à tout moment.</li></ul>"},
  {q:"L'adhésif va-t-il endommager mon mur ?", a:"<p>Cela dépend de la surface de votre mur et de l'état de la peinture. Nous recommandons toujours de retirer l'adhésif avec des mouvements de torsion lents et prudents.</p>"}
];

// Collection that holds the multi-card combo displays (2-3 cards in one design).
// This is the authoritative source for which products count as "multi" — some of
// these products still carry a Standard/Premium option (and are priced the same
// as single-card frames), so cardType can't be inferred from variant structure.
const MULTI_FRAME_COLLECTION_HANDLE = "multi-frame";

// Free standard shipping thresholds per currency, sourced from /pages/shipping.
// EUR/GBP/USD/CAD/AUD are the exact stated thresholds. The remaining EU-market
// currencies (CZK, DKK, HUF, PLN, RON, SEK) are approximate €75 equivalents
// converted at rates as of 2026-07-23 — review periodically as FX rates drift.
const FREE_SHIPPING_THRESHOLDS = {
  EUR: 75, GBP: 65, USD: 75, CAD: 120, AUD: 125,
  CZK: 1810, DKK: 560, HUF: 27250, PLN: 325, RON: 390, SEK: 830
};
function currencyCode(){ return (window.WB_CURRENCY_CODE || "EUR").toUpperCase(); }

// Tags that describe the product's own catalog/shape rather than its set/franchise —
// these exist on every product in a catalog, so they're excluded from the tag filter.
const STRUCTURAL_TAGS = new Set(["Hexagon", "Framed"]);

// Small/Large physical dimensions shown under the size toggle. These are the Hexagon
// display sizes (Europe cm / International inches, matching the FAQ) — Framed sizes
// aren't standardized the same way, so the subtext is only shown in hexagon mode.
// NL/DE don't use inches, so those languages show cm only; EN/ES/FR also serve
// US/CA customers, so they show both units.
const SIZE_DIMS_FULL = { A: "20×17 cm / 7×6″", B: "25×21 cm / 9×8″" };
const SIZE_DIMS_CM = { A: "20×17 cm", B: "25×21 cm" };
function sizeDimsForLang(){
  return (currentLang === "nl" || currentLang === "de") ? SIZE_DIMS_CM : SIZE_DIMS_FULL;
}
function renderSizeDims(){
  const dimA = document.getElementById("wbDefADim");
  const dimB = document.getElementById("wbDefBDim");
  if(!dimA || !dimB) return;
  if(currentMode !== "hexagon"){
    dimA.textContent = "";
    dimB.textContent = "";
    return;
  }
  const dims = sizeDimsForLang();
  dimA.textContent = dims.A;
  dimB.textContent = dims.B;
}

// Translated labels for the Small/Large size toggle. The underlying Shopify variant
// titles are plain English ("Small"/"Large"), so we translate known values here and
// fall back to the raw variant title for anything that doesn't match (e.g. if a
// Framed product ever uses different variant naming).
const SIZE_LABEL_MAP = {
  small: { en: "Small", nl: "Klein", de: "Klein", es: "Pequeño", fr: "Petit" },
  large: { en: "Large", nl: "Groot", de: "Groß", es: "Grande", fr: "Grand" },
  black: { en: "Black", nl: "Zwart", de: "Schwarz", es: "Negro", fr: "Noir" },
  white: { en: "White", nl: "Wit", de: "Weiß", es: "Blanco", fr: "Blanc" }
};
function translatedSizeLabel(rawTitle){
  const key = (rawTitle || "").trim().toLowerCase();
  const map = SIZE_LABEL_MAP[key];
  return map ? (map[currentLang] || map.en) : rawTitle;
}
function renderSizeToggleLabels(){
  const labelA = document.getElementById("wbDefALabel");
  const labelB = document.getElementById("wbDefBLabel");
  if(!labelA || !labelB || !PRODUCTS[0]) return;
  labelA.textContent = translatedSizeLabel(PRODUCTS[0].titleA);
  labelB.textContent = translatedSizeLabel(PRODUCTS[0].titleB);
}

const I18N = {
  en: { badge:"Wall Builder", hint:"Build your wall visually, drag to rearrange, and see automatically when you've unlocked free displays.",
    modeHexagon:"Hexagons", modeFramed:"Frames",
    catalogHeading:"Choose designs", catalogLoading:"Loading designs…", catalogSub:n=>`${n} designs available.`,
    searchPlaceholder:"Search a design, e.g. Charizard", addAsLabel:"Size", addAsLabelColor:"Color",
    frameTypeLabel:"Frame", frameTypeStandard:"Standard", frameTypePremium:"Premium",
    cardTypeLabel:"Type", cardTypeSingle:"Single", cardTypeMulti:"Multi-Card",
    bundleHeadingHexagon:"Hexagon Bundle Deals", bundleHeadingFramed:"Frame Bundle Deals",
    freeBannerTitle:n=>`Free display${n>1?'s':''} unlocked!`, freeBannerText:n=>`Choose ${n} more free display${n>1?'s':''} below — they'll be marked FREE.`,
    addBtn:"+ Add", addFreeBtn:"+ Choose free", noResults:"No designs found",
    wallTitle:n=>`Your wall — ${n} display${n===1?'':'s'}`, clearWall:"Clear",
    emptyHint:'Click "+ Add" on a design to start building your wall.',
    overviewHeading:"Summary",
    paidLabel:"Paid displays", freeLabel:"Free displays", originalPriceLabel:"Original price", saveLabel:"You save", totalLabel:"Total",
    nextTier:(r,f)=>`Add <b>${r}</b> more display${r>1?'s':''} to unlock <b>${f} free</b> display${f>1?'s':''}.`,
    maxTier:f=>`You've reached the highest tier — <b>${f} free</b> display${f>1?'s':''} unlocked.`,
    ctaBtn:"Add all to cart", ctaBusy:"Adding to cart…", protoNote:"Bundle discounts are applied automatically — no code needed.",
    toastFreeAdded:"Free display added", toastTierUnlocked:n=>`Tier reached: choose ${n} free display${n>1?'s':''} now!`,
    toastDemoFilled:"Example wall loaded — drag the displays to rearrange them", toastEmptyCart:"Add displays to your wall first",
    toastCartError:"Couldn't add to cart. Please try again.", toastModeSwitch:"Switched catalog — your wall was cleared", gratisBadge:"FREE",
    tierBuy:n=>`Buy ${n}`, tierGet:n=>`Get ${n} FREE`,
    freeShipProgress:r=>`You're <b>${r}</b> away from free shipping!`, freeShipUnlocked:"You've unlocked free shipping!",
    reviewsBadge:(r,c)=>`${r}/5 · ${c} reviews`,
    filterByTag:"Filter by tag", filterClear:"Clear filters",
    filterSearchPlaceholder:"Search tags…", filterNoTags:"No matching tags",
    modeNote:"Hexagons and Frames are built and added to cart separately.",
    switchConfirmText:"Switching catalogs will clear your current wall. Continue?",
    faqHeading:"FAQ", faqItems: FAQ_ITEMS_EN },
  nl: { badge:"Wall Builder", hint:"Bouw je muur visueel, sleep om te herschikken, en zie automatisch wanneer je gratis displays opengespeeld hebt.",
    modeHexagon:"Hexagons", modeFramed:"Frames",
    catalogHeading:"Kies designs", catalogLoading:"Designs laden…", catalogSub:n=>`${n} designs beschikbaar.`,
    searchPlaceholder:"Zoek een design, bv. Charizard", addAsLabel:"Formaat", addAsLabelColor:"Kleur",
    frameTypeLabel:"Uitvoering", frameTypeStandard:"Standaard", frameTypePremium:"Premium",
    cardTypeLabel:"Type", cardTypeSingle:"Los", cardTypeMulti:"Multi-Card",
    bundleHeadingHexagon:"Hexagon Bundeldeals", bundleHeadingFramed:"Frame Bundeldeals",
    freeBannerTitle:n=>`Gratis display${n>1?'s':''} ontgrendeld!`, freeBannerText:n=>`Kies nog ${n} gratis display${n>1?'s':''} hieronder — ze worden gemarkeerd als GRATIS.`,
    addBtn:"+ Toevoegen", addFreeBtn:"+ Gratis kiezen", noResults:"Geen designs gevonden",
    wallTitle:n=>`Jouw muur — ${n} display${n===1?'':'s'}`, clearWall:"Leegmaken",
    emptyHint:'Klik op "+ Toevoegen" bij een design om je muur te bouwen.',
    overviewHeading:"Overzicht",
    paidLabel:"Betaalde displays", freeLabel:"Gratis displays", originalPriceLabel:"Oorspronkelijke prijs", saveLabel:"Je bespaart", totalLabel:"Totaal",
    nextTier:(r,f)=>`Voeg nog <b>${r}</b> display${r>1?'s':''} toe om <b>${f} gratis</b> display${f>1?'s':''} open te spelen.`,
    maxTier:f=>`Je hebt de hoogste staffel bereikt — <b>${f} gratis</b> display${f>1?'s':''} beschikbaar.`,
    ctaBtn:"Voeg alles toe aan winkelmandje", ctaBusy:"Toevoegen…", protoNote:"Staffelkorting wordt automatisch toegepast — geen code nodig.",
    toastFreeAdded:"Gratis display toegevoegd", toastTierUnlocked:n=>`Staffel bereikt: kies nu ${n} gratis display${n>1?'s':''}!`,
    toastDemoFilled:"Voorbeeldmuur geladen — sleep de displays om ze te herschikken", toastEmptyCart:"Voeg eerst displays toe aan je muur",
    toastCartError:"Toevoegen aan winkelmandje mislukt. Probeer opnieuw.", toastModeSwitch:"Catalogus gewisseld — je muur is geleegd", gratisBadge:"GRATIS",
    tierBuy:n=>`Koop ${n}`, tierGet:n=>`Krijg ${n} GRATIS`,
    freeShipProgress:r=>`Je bent nog <b>${r}</b> verwijderd van gratis verzending!`, freeShipUnlocked:"Je hebt gratis verzending ontgrendeld!",
    reviewsBadge:(r,c)=>`${r}/5 · ${c} beoordelingen`,
    filterByTag:"Filter op tag", filterClear:"Filters wissen",
    filterSearchPlaceholder:"Zoek tags…", filterNoTags:"Geen overeenkomende tags",
    modeNote:"Hexagons en Frames worden apart opgebouwd en toegevoegd aan je winkelmandje.",
    switchConfirmText:"Als je wisselt van catalogus wordt je huidige muur geleegd. Doorgaan?",
    faqHeading:"Veelgestelde vragen", faqItems: FAQ_ITEMS_NL },
  de: { badge:"Wall Builder", hint:"Baue deine Wand visuell, ziehe zum Anordnen, und sieh automatisch, wann du gratis Displays freigeschaltet hast.",
    modeHexagon:"Hexagons", modeFramed:"Rahmen",
    catalogHeading:"Designs wählen", catalogLoading:"Designs werden geladen…", catalogSub:n=>`${n} Designs verfügbar.`,
    searchPlaceholder:"Design suchen, z. B. Charizard", addAsLabel:"Größe", addAsLabelColor:"Farbe",
    frameTypeLabel:"Rahmentyp", frameTypeStandard:"Standard", frameTypePremium:"Premium",
    cardTypeLabel:"Typ", cardTypeSingle:"Einzeln", cardTypeMulti:"Multi-Card",
    bundleHeadingHexagon:"Hexagon Bundle-Angebote", bundleHeadingFramed:"Rahmen Bundle-Angebote",
    freeBannerTitle:n=>`Gratis Display${n>1?'s':''} freigeschaltet!`, freeBannerText:n=>`Wähle unten noch ${n} gratis Display${n>1?'s':''} aus — sie werden als GRATIS markiert.`,
    addBtn:"+ Hinzufügen", addFreeBtn:"+ Gratis wählen", noResults:"Keine Designs gefunden",
    wallTitle:n=>`Deine Wand — ${n} Display${n===1?'':'s'}`, clearWall:"Leeren",
    emptyHint:'Klicke auf "+ Hinzufügen" bei einem Design, um deine Wand zu bauen.',
    overviewHeading:"Übersicht",
    paidLabel:"Bezahlte Displays", freeLabel:"Gratis Displays", originalPriceLabel:"Ursprünglicher Preis", saveLabel:"Du sparst", totalLabel:"Gesamt",
    nextTier:(r,f)=>`Füge noch <b>${r}</b> Display${r>1?'s':''} hinzu, um <b>${f} gratis</b> Display${f>1?'s':''} freizuschalten.`,
    maxTier:f=>`Du hast die höchste Stufe erreicht — <b>${f} gratis</b> Display${f>1?'s':''} freigeschaltet.`,
    ctaBtn:"Alles in den Warenkorb", ctaBusy:"Wird hinzugefügt…", protoNote:"Mengenrabatte werden automatisch angewendet — kein Code nötig.",
    toastFreeAdded:"Gratis Display hinzugefügt", toastTierUnlocked:n=>`Stufe erreicht: wähle jetzt ${n} gratis Display${n>1?'s':''}!`,
    toastDemoFilled:"Beispielwand geladen — ziehe die Displays, um sie neu anzuordnen", toastEmptyCart:"Füge zuerst Displays zu deiner Wand hinzu",
    toastCartError:"Hinzufügen zum Warenkorb fehlgeschlagen. Bitte versuche es erneut.", toastModeSwitch:"Katalog gewechselt — deine Wand wurde geleert", gratisBadge:"GRATIS",
    tierBuy:n=>`Kaufe ${n}`, tierGet:n=>`Erhalte ${n} GRATIS`,
    freeShipProgress:r=>`Du bist noch <b>${r}</b> von gratis Versand entfernt!`, freeShipUnlocked:"Du hast gratis Versand freigeschaltet!",
    reviewsBadge:(r,c)=>`${r}/5 · ${c} Bewertungen`,
    filterByTag:"Nach Tag filtern", filterClear:"Filter zurücksetzen",
    filterSearchPlaceholder:"Tags suchen…", filterNoTags:"Keine passenden Tags",
    modeNote:"Hexagons und Rahmen werden separat aufgebaut und in den Warenkorb gelegt.",
    switchConfirmText:"Beim Wechseln des Katalogs wird deine aktuelle Wand geleert. Fortfahren?",
    faqHeading:"Häufige Fragen", faqItems: FAQ_ITEMS_DE },
  es: { badge:"Wall Builder", hint:"Diseña tu pared visualmente, arrastra para reorganizar y descubre automáticamente cuándo has desbloqueado displays gratis.",
    modeHexagon:"Hexágonos", modeFramed:"Marcos",
    catalogHeading:"Elige diseños", catalogLoading:"Cargando diseños…", catalogSub:n=>`${n} diseños disponibles.`,
    searchPlaceholder:"Busca un diseño, p. ej. Charizard", addAsLabel:"Tamaño", addAsLabelColor:"Color",
    frameTypeLabel:"Tipo de marco", frameTypeStandard:"Estándar", frameTypePremium:"Premium",
    cardTypeLabel:"Tipo", cardTypeSingle:"Individual", cardTypeMulti:"Multi-Carta",
    bundleHeadingHexagon:"Ofertas de Hexágonos", bundleHeadingFramed:"Ofertas de Marcos",
    freeBannerTitle:n=>`¡Has desbloqueado ${n} display${n>1?'s':''} gratis!`, freeBannerText:n=>`Elige ${n} display${n>1?'s':''} gratis más abajo — se marcarán como GRATIS.`,
    addBtn:"+ Añadir", addFreeBtn:"+ Elegir gratis", noResults:"No se encontraron diseños",
    wallTitle:n=>`Tu pared — ${n} display${n===1?'':'s'}`, clearWall:"Vaciar",
    emptyHint:'Haz clic en "+ Añadir" en un diseño para empezar a construir tu pared.',
    overviewHeading:"Resumen",
    paidLabel:"Displays de pago", freeLabel:"Displays gratis", originalPriceLabel:"Precio original", saveLabel:"Ahorras", totalLabel:"Total",
    nextTier:(r,f)=>`Añade <b>${r}</b> display${r>1?'s':''} más para desbloquear <b>${f}</b> display${f>1?'s':''} gratis.`,
    maxTier:f=>`Has alcanzado el nivel más alto — ya has desbloqueado <b>${f}</b> display${f>1?'s':''} gratis.`,
    ctaBtn:"Añadir todo al carrito", ctaBusy:"Añadiendo al carrito…", protoNote:"Los descuentos por volumen se aplican automáticamente — no se necesita código.",
    toastFreeAdded:"Display gratis añadido", toastTierUnlocked:n=>`¡Nivel alcanzado: elige ${n} display${n>1?'s':''} gratis ahora!`,
    toastDemoFilled:"Pared de ejemplo cargada — arrastra los displays para reorganizarlos", toastEmptyCart:"Añade displays a tu pared primero",
    toastCartError:"No se pudo añadir al carrito. Inténtalo de nuevo.", toastModeSwitch:"Catálogo cambiado — tu pared se ha vaciado", gratisBadge:"GRATIS",
    tierBuy:n=>`Compra ${n}`, tierGet:n=>`Consigue ${n} GRATIS`,
    freeShipProgress:r=>`Te faltan <b>${r}</b> para el envío gratis!`, freeShipUnlocked:"¡Has desbloqueado el envío gratis!",
    reviewsBadge:(r,c)=>`${r}/5 · ${c} reseñas`,
    filterByTag:"Filtrar por etiqueta", filterClear:"Borrar filtros",
    filterSearchPlaceholder:"Buscar etiquetas…", filterNoTags:"No hay etiquetas coincidentes",
    modeNote:"Los hexágonos y los marcos se construyen y añaden al carrito por separado.",
    switchConfirmText:"Cambiar de catálogo vaciará tu pared actual. ¿Continuar?",
    faqHeading:"Preguntas frecuentes", faqItems: FAQ_ITEMS_ES },
  fr: { badge:"Wall Builder", hint:"Composez votre mur visuellement, glissez pour réorganiser, et découvrez automatiquement quand vous débloquez des displays gratuits.",
    modeHexagon:"Hexagones", modeFramed:"Cadres",
    catalogHeading:"Choisir des designs", catalogLoading:"Chargement des designs…", catalogSub:n=>`${n} designs disponibles.`,
    searchPlaceholder:"Rechercher un design, ex. Charizard", addAsLabel:"Taille", addAsLabelColor:"Couleur",
    frameTypeLabel:"Type de cadre", frameTypeStandard:"Standard", frameTypePremium:"Premium",
    cardTypeLabel:"Type", cardTypeSingle:"Simple", cardTypeMulti:"Multi-Carte",
    bundleHeadingHexagon:"Offres Groupées Hexagones", bundleHeadingFramed:"Offres Groupées Cadres",
    freeBannerTitle:n=>`Vous avez débloqué ${n} display${n>1?'s':''} gratuit${n>1?'s':''} !`, freeBannerText:n=>`Choisissez ${n} display${n>1?'s':''} gratuit${n>1?'s':''} de plus ci-dessous — ils seront marqués GRATUIT.`,
    addBtn:"+ Ajouter", addFreeBtn:"+ Choisir gratuit", noResults:"Aucun design trouvé",
    wallTitle:n=>`Votre mur — ${n} display${n===1?'':'s'}`, clearWall:"Vider",
    emptyHint:'Cliquez sur "+ Ajouter" sur un design pour commencer à composer votre mur.',
    overviewHeading:"Résumé",
    paidLabel:"Displays payants", freeLabel:"Displays gratuits", originalPriceLabel:"Prix d'origine", saveLabel:"Vous économisez", totalLabel:"Total",
    nextTier:(r,f)=>`Ajoutez <b>${r}</b> display${r>1?'s':''} de plus pour débloquer <b>${f}</b> display${f>1?'s':''} gratuit${f>1?'s':''}.`,
    maxTier:f=>`Vous avez atteint le palier le plus élevé — vous avez débloqué <b>${f}</b> display${f>1?'s':''} gratuit${f>1?'s':''}.`,
    ctaBtn:"Tout ajouter au panier", ctaBusy:"Ajout au panier…", protoNote:"Les remises par palier s'appliquent automatiquement — aucun code requis.",
    toastFreeAdded:"Display gratuit ajouté", toastTierUnlocked:n=>`Palier atteint : choisissez ${n} display${n>1?'s':''} gratuit${n>1?'s':''} maintenant !`,
    toastDemoFilled:"Mur d'exemple chargé — faites glisser les displays pour les réorganiser", toastEmptyCart:"Ajoutez d'abord des displays à votre mur",
    toastCartError:"Impossible d'ajouter au panier. Veuillez réessayer.", toastModeSwitch:"Catalogue changé — votre mur a été vidé", gratisBadge:"GRATUIT",
    tierBuy:n=>`Achetez ${n}`, tierGet:n=>`Obtenez ${n} GRATUIT`,
    freeShipProgress:r=>`Il vous manque <b>${r}</b> pour la livraison gratuite !`, freeShipUnlocked:"Vous avez débloqué la livraison gratuite !",
    reviewsBadge:(r,c)=>`${r}/5 · ${c} avis`,
    filterByTag:"Filtrer par tag", filterClear:"Effacer les filtres",
    filterSearchPlaceholder:"Rechercher des tags…", filterNoTags:"Aucun tag correspondant",
    modeNote:"Les hexagones et les cadres sont construits et ajoutés au panier séparément.",
    switchConfirmText:"Changer de catalogue videra votre mur actuel. Continuer ?",
    faqHeading:"Questions fréquentes", faqItems: FAQ_ITEMS_FR }
};

let currentMode = "hexagon";
let PRODUCTS = [];
let rawProducts = [];
let wall = [];
let defaultVariant = "A";
let frameType = "standard"; // "standard" | "premium" — only relevant in framed mode
let cardType = "single"; // "single" | "multi" — catalog filter, only relevant in framed mode
let multiFrameIds = new Set(); // product ids from the "Multi-Frame" collection — authoritative source for cardType classification
let currentLang = (document.documentElement.lang || "en").slice(0,2) in I18N ? (document.documentElement.lang || "en").slice(0,2) : "en";
let colHeights = [];
let catalogLoaded = false;
let fetchToken = 0;
let activeTags = new Set();
let ALL_TAGS = [];
let tagFilterSearch = "";

function T(){ return I18N[currentLang] || I18N.en; }
function M(){ return MODES[currentMode]; }

function targetFreeFor(paidCount){
  let f = 0;
  for(const tier of M().tiers){ if(paidCount >= tier.paid) f = tier.free; }
  return f;
}
function nextTierOf(paidCount){ return M().tiers.find(t => paidCount < t.paid) || null; }

// All Framed products (including Multi-Frame combo displays) participate in
// the buy-X-get-Y-free bundle mechanic — every paid item counts toward tiers.
function bundleEligiblePaidCount(){
  return wall.filter(w => !w.free && w.bundleEligible !== false).length;
}

function enforceFreeCap(){
  let guard = 0;
  while(guard++ < wall.length + 1){
    const paidCount = bundleEligiblePaidCount();
    const target = targetFreeFor(paidCount);
    const freeIdxs = [];
    wall.forEach((w,i) => { if(w.free) freeIdxs.push(i); });
    if(freeIdxs.length <= target) break;
    // demote the most recently added free item back to paid
    wall[freeIdxs[freeIdxs.length - 1]].free = false;
  }
}

async function fetchCollectionAll(handle){
  const out = [];
  let page = 1;
  while(page <= 8){
    const res = await fetch(`/collections/${handle}/products.json?limit=250&page=${page}`);
    if(!res.ok) break;
    const data = await res.json();
    const batch = data.products || [];
    out.push(...batch);
    if(batch.length < 250) break;
    page++;
  }
  return out;
}

// Framed products can (but don't always) have a "Standard"/"Premium" frame-type
// option ahead of the Black/White color option (e.g. "Premium / Black"). Older
// Framed products only have Black/White. This picks the color pair (vA=Black,
// vB=White) that matches the currently selected frame type, falling back to
// whatever variants exist when a product doesn't offer that frame type.
function pickFramedVariants(variants, wantedFrameType){
  const hasFrameTypeOption = variants.some(v => /premium/i.test(v.title) || /standard/i.test(v.title));
  let pool = variants;
  if(hasFrameTypeOption){
    const wanted = wantedFrameType === "premium" ? /premium/i : /standard/i;
    const matched = variants.filter(v => wanted.test(v.title));
    if(matched.length) pool = matched;
  }
  const vA = pool.find(v => /black/i.test(v.title)) || pool[0];
  const vB = pool.find(v => /white/i.test(v.title)) || pool[1] || vA;
  return { vA, vB, hasFrameTypeOption };
}

// Strips a leading option (e.g. "Premium / Black" -> "Black") so the on-tile
// variant label only shows the color, not the frame type (which is now its
// own separate selector).
function colorPart(title){
  if(!title) return title;
  const parts = title.split("/").map(s => s.trim());
  return parts.length > 1 ? parts[parts.length - 1] : parts[0];
}

function mapRawProducts(raw){
  return raw.map(p => {
    let vA, vB, cardTypeOf = "single";
    if(currentMode === "framed"){
      const picked = pickFramedVariants(p.variants, frameType);
      vA = picked.vA; vB = picked.vB;
      // Multi-card classification comes from membership in the "Multi-Frame"
      // collection, not variant structure — some multi-card designs still carry
      // a Standard/Premium option and are priced the same as single-card frames.
      cardTypeOf = multiFrameIds.has(p.id) ? "multi" : "single";
    } else {
      vA = p.variants.find(v => /small/i.test(v.title)) || p.variants[0];
      vB = p.variants.find(v => /large/i.test(v.title)) || p.variants[1] || vA;
    }
    const fallbackImg = (p.images && p.images[0] && p.images[0].src) || "";
    const imgOf = v => (v && v.featured_image && v.featured_image.src) || fallbackImg;
    const withSize = src => src ? src + (src.includes("?") ? "&" : "?") + "width=300" : "";
    const labelOf = (v, fallback) => {
      if(!v) return fallback;
      return currentMode === "framed" ? colorPart(v.title) : v.title.replace(/\s*\(.*?\)\s*/g, "").trim();
    };
    return {
      t: p.title,
      tags: Array.isArray(p.tags) ? p.tags : (typeof p.tags === "string" ? p.tags.split(",").map(s => s.trim()) : []),
      cardType: cardTypeOf,
      idA: vA ? vA.id : null,
      idB: vB ? vB.id : null,
      priceA: vA ? parseFloat(vA.price) : 0,
      priceB: vB ? parseFloat(vB.price) : 0,
      titleA: labelOf(vA, "A"),
      titleB: labelOf(vB, "B"),
      imgA: withSize(imgOf(vA)),
      imgB: withSize(imgOf(vB))
    };
  }).filter(p => p.idA);
}

async function fetchCatalog(){
  const myToken = ++fetchToken;
  catalogLoaded = false;
  renderCatalog();
  let raw = [];
  try {
    const fetches = M().collections.map(fetchCollectionAll);
    if(currentMode === "framed") fetches.push(fetchCollectionAll(MULTI_FRAME_COLLECTION_HANDLE));
    const results = await Promise.all(fetches);
    if(currentMode === "framed"){
      const multiRaw = results.pop();
      multiFrameIds = new Set(multiRaw.map(p => p.id));
    } else {
      multiFrameIds = new Set();
    }
    raw = results.flat();
  } catch(e){ console.error("Wall Builder: catalog fetch failed", e); }
  if(myToken !== fetchToken) return; // a newer fetch superseded this one

  rawProducts = raw;
  PRODUCTS = mapRawProducts(raw);

  ALL_TAGS = Array.from(new Set(PRODUCTS.flatMap(p => p.tags)))
    .filter(t => !STRUCTURAL_TAGS.has(t))
    .sort((a, b) => a.localeCompare(b));
  Array.from(activeTags).forEach(t => { if(!ALL_TAGS.includes(t)) activeTags.delete(t); });

  catalogLoaded = true;
  renderSizeToggleLabels();
  renderSizeDims();
  renderFrameTypeUI();
  renderCardTypeUI();
  renderTagFilter();
  render();
}

// Re-maps the already-fetched raw products for a new frame type selection,
// without hitting the network again.
function remapCatalog(){
  PRODUCTS = mapRawProducts(rawProducts);
  renderSizeToggleLabels();
  render();
}

function switchMode(mode){
  if(mode === currentMode) return;
  if(wall.length > 0 && !window.confirm(T().switchConfirmText)) return;
  currentMode = mode;
  wall = [];
  colHeights = [];
  cardType = "single";
  document.getElementById("wbModeHex").classList.toggle("wb-active", mode === "hexagon");
  document.getElementById("wbModeFramed").classList.toggle("wb-active", mode === "framed");
  const cardSingleBtn = document.getElementById("wbCardSingle");
  const cardMultiBtn = document.getElementById("wbCardMulti");
  if(cardSingleBtn) cardSingleBtn.classList.add("wb-active");
  if(cardMultiBtn) cardMultiBtn.classList.remove("wb-active");
  updateAddAsLabel();
  renderFrameTypeUI();
  renderCardTypeUI();
  showToast(T().toastModeSwitch);
  fetchCatalog();
}

function updateAddAsLabel(){
  const el = document.querySelector('.wb-add-size-row > [data-i18n="addAsLabel"]');
  if(el) el.textContent = currentMode === "framed" ? T().addAsLabelColor : T().addAsLabel;
}

function renderFrameTypeUI(){
  const row = document.getElementById("wbFrameTypeRow");
  if(!row) return;
  // Some Multi-Frame products still carry a Standard/Premium option (e.g. two-
  // character combo prints at the same €35/€59 pricing as single-card frames),
  // so this stays visible for all of Framed mode — pickFramedVariants() falls
  // back gracefully for products that don't offer the option.
  row.style.display = currentMode === "framed" ? "flex" : "none";
  const label = row.querySelector('[data-i18n="frameTypeLabel"]');
  if(label) label.textContent = T().frameTypeLabel;
  const stdLabel = document.getElementById("wbFrameStandardLabel");
  const premLabel = document.getElementById("wbFramePremiumLabel");
  if(stdLabel) stdLabel.textContent = T().frameTypeStandard;
  if(premLabel) premLabel.textContent = T().frameTypePremium;
}

function renderCardTypeUI(){
  const row = document.getElementById("wbCardTypeRow");
  if(!row) return;
  row.style.display = currentMode === "framed" ? "flex" : "none";
  const label = row.querySelector('[data-i18n="cardTypeLabel"]');
  if(label) label.textContent = T().cardTypeLabel;
  const singleLabel = document.getElementById("wbCardSingleLabel");
  const multiLabel = document.getElementById("wbCardMultiLabel");
  if(singleLabel) singleLabel.textContent = T().cardTypeSingle;
  if(multiLabel) multiLabel.textContent = T().cardTypeMulti;
}

function applyStaticLang(){
  document.documentElement.lang = currentLang;
  document.querySelectorAll("[data-i18n]").forEach(el => {
    const key = el.getAttribute("data-i18n");
    const val = T()[key];
    if(typeof val === "string") el.textContent = val;
  });
  document.getElementById("wbSearch").placeholder = T().searchPlaceholder;
  document.getElementById("wbEmptyHint").textContent = T().emptyHint;
  document.getElementById("wbModeHex").textContent = T().modeHexagon;
  document.getElementById("wbModeFramed").textContent = T().modeFramed;
  updateAddAsLabel();
  renderFrameTypeUI();
  renderCardTypeUI();
  renderSizeToggleLabels();
  renderSizeDims();
  renderReviewsBadge();
  renderTagFilter();
  renderFAQ();
}

function renderTagFilter(){
  const btn = document.getElementById("wbTagFilterBtn");
  const label = document.getElementById("wbTagFilterLabel");
  const count = document.getElementById("wbTagFilterCount");
  const search = document.getElementById("wbTagFilterSearch");
  const options = document.getElementById("wbTagFilterOptions");
  const clearBtn = document.getElementById("wbTagFilterClearBtn");
  if(!btn || !options) return;

  label.textContent = T().filterByTag;
  if(activeTags.size > 0){
    count.textContent = activeTags.size;
    count.classList.add("wb-show");
  } else {
    count.classList.remove("wb-show");
  }
  if(search) search.placeholder = T().filterSearchPlaceholder;
  if(clearBtn) clearBtn.textContent = T().filterClear;

  const term = tagFilterSearch.trim().toLowerCase();
  const visibleTags = term ? ALL_TAGS.filter(t => t.toLowerCase().includes(term)) : ALL_TAGS;

  options.innerHTML = "";
  if(visibleTags.length === 0){
    options.innerHTML = `<div class="wb-tagfilter-empty">${T().filterNoTags}</div>`;
    return;
  }
  visibleTags.forEach(tag => {
    const opt = document.createElement("label");
    opt.className = "wb-tagfilter-option";
    const cb = document.createElement("input");
    cb.type = "checkbox";
    cb.checked = activeTags.has(tag);
    cb.addEventListener("change", () => {
      if(cb.checked) activeTags.add(tag); else activeTags.delete(tag);
      renderTagFilter();
      renderCatalog();
    });
    const span = document.createElement("span");
    span.textContent = tag;
    opt.appendChild(cb);
    opt.appendChild(span);
    options.appendChild(opt);
  });
}

function renderReviewsBadge(){
  const badge = document.getElementById("wbReviewsBadge");
  const text = document.getElementById("wbReviewsText");
  if(!badge || !text) return;
  const count = window.WB_REVIEW_COUNT || 0;
  const rating = window.WB_REVIEW_RATING || 0;
  if(count > 0){
    badge.classList.add("wb-show");
    text.textContent = T().reviewsBadge(rating, count);
  } else {
    badge.classList.remove("wb-show");
  }
}

function renderFAQ(){
  const list = document.getElementById("wbFaqList");
  if(!list) return;
  list.innerHTML = "";
  T().faqItems.forEach(item => {
    const wrap = document.createElement("div");
    wrap.className = "wb-faq-item";
    wrap.innerHTML = `
      <button class="wb-faq-q" type="button">
        <span>${item.q}</span>
        <span class="wb-faq-icon">+</span>
      </button>
      <div class="wb-faq-a">${item.a}</div>
    `;
    wrap.querySelector(".wb-faq-q").addEventListener("click", () => {
      wrap.classList.toggle("wb-faq-open");
    });
    list.appendChild(wrap);
  });
}

function renderCatalog(){
  const q = document.getElementById("wbSearch").value.trim().toLowerCase();
  const grid = document.getElementById("wbCatGrid");
  const sub = document.getElementById("wbCatSub");

  if(!catalogLoaded){
    sub.textContent = T().catalogLoading;
    grid.innerHTML = "";
    return;
  }
  sub.textContent = T().catalogSub(PRODUCTS.length);

  const freeRemaining = Math.max(0, targetFreeFor(bundleEligiblePaidCount()) - wall.filter(w=>w.free).length);
  const filtered = PRODUCTS.filter(p => {
    if(!p.t.toLowerCase().includes(q)) return false;
    if(activeTags.size > 0 && !p.tags.some(t => activeTags.has(t))) return false;
    if(currentMode === "framed" && p.cardType !== cardType) return false;
    return true;
  });
  grid.innerHTML = "";
  if(filtered.length === 0){
    grid.innerHTML = `<div class="wb-no-results">${T().noResults}</div>`;
    return;
  }
  filtered.slice(0, 120).forEach(p => {
    const thumb = defaultVariant === "B" ? p.imgB : p.imgA;
    const price = defaultVariant === "B" ? p.priceB : p.priceA;
    // Multi-card combo displays participate in bundle deals like any other
    // Framed product — they count toward tiers and can be chosen as free.
    const isBundleEligible = true;
    const offerFree = isBundleEligible && freeRemaining > 0;
    const el = document.createElement("div");
    el.className = "wb-cat-item" + (offerFree ? " wb-free-mode" : "");
    const shapeClass = M().shape === "hex" ? "wb-shape-hex" : "wb-shape-rect";
    el.innerHTML = `
      <div class="wb-thumb-wrap"><img class="wb-thumb ${shapeClass}" src="${thumb}" alt="" loading="lazy"></div>
      <div class="wb-item-title">${p.t}</div>
      <div class="wb-item-price">${fmtMoney(price)}</div>
      <button class="wb-add-btn">${offerFree ? T().addFreeBtn : T().addBtn}</button>
    `;
    el.querySelector(".wb-add-btn").onclick = () => addToWall(p, offerFree, isBundleEligible);
    grid.appendChild(el);
  });
}

function addToWall(product, asFree, bundleEligible){
  if(bundleEligible === undefined) bundleEligible = true;
  const pos = nextAutoPosition(defaultVariant);
  wall.push({
    t: product.t, imgA: product.imgA, imgB: product.imgB,
    idA: product.idA, idB: product.idB,
    priceA: product.priceA, priceB: product.priceB,
    titleA: product.titleA, titleB: product.titleB,
    free: asFree, bundleEligible: bundleEligible, variant: defaultVariant, shape: M().shape, x: pos.x, y: pos.y
  });
  render();
  if(asFree){
    showToast(T().toastFreeAdded);
  } else if(bundleEligible){
    const paidCount = bundleEligiblePaidCount();
    const justUnlocked = M().tiers.find(t => t.paid === paidCount);
    if(justUnlocked) showToast(T().toastTierUnlocked(justUnlocked.free));
  }
}

function removeFromWall(index){ wall.splice(index, 1); render(); }
function toggleItemVariant(index){
  const item = wall[index];
  const oldMult = item.variant === "B" ? M().multB : 1;
  item.variant = item.variant === "A" ? "B" : "A";
  const newMult = item.variant === "B" ? M().multB : 1;
  const base = baseTileWidth(getContainerWidth());
  const delta = (base * newMult - base * oldMult) / 2;
  item.x -= delta;
  item.y -= delta * M().aspect;
  render();
}

function showToast(msg){
  const t = document.getElementById("wbToast");
  t.textContent = msg;
  t.classList.add("wb-show");
  clearTimeout(window._wbToastTimer);
  window._wbToastTimer = setTimeout(() => t.classList.remove("wb-show"), 2600);
}

function baseTileWidth(containerWidth){
  return Math.max(64, Math.min(108, containerWidth / 5));
}
function getContainerWidth(){
  const inner = document.querySelector(".wb-canvas-inner");
  return (inner && inner.clientWidth) || 560;
}

function nextAutoPosition(variant){
  const containerWidth = getContainerWidth();
  const base = baseTileWidth(containerWidth);
  const gap = 10;
  const colWidth = base * Math.max(M().multB, 1) + gap;
  const cols = Math.max(2, Math.floor(containerWidth / colWidth));
  if(colHeights.length !== cols){
    colHeights = new Array(cols).fill(0).map((_, c) => (c % 2 === 1 ? (base * M().aspect) / 2 : 0));
  }
  const mult = variant === "B" ? M().multB : 1;
  const w = base * mult;
  const h = w * M().aspect;
  let col = 0;
  for(let c = 1; c < cols; c++){ if(colHeights[c] < colHeights[col]) col = c; }
  const x = col * colWidth + (colWidth - gap - w) / 2;
  const y = colHeights[col];
  colHeights[col] = y + h * 0.85 + 6;
  return { x, y };
}

function renderWall(){
  const containerWidth = getContainerWidth();
  const base = baseTileWidth(containerWidth);
  const field = document.getElementById("wbHexField");
  const emptyHint = document.getElementById("wbEmptyHint");
  emptyHint.style.display = wall.length === 0 ? "flex" : "none";

  let maxRight = containerWidth, maxBottom = 0;
  wall.forEach(item => {
    const mult = item.variant === "B" ? M().multB : 1;
    const w = base * mult;
    const h = w * M().aspect;
    maxRight = Math.max(maxRight, item.x + w);
    maxBottom = Math.max(maxBottom, item.y + h);
  });
  field.style.width = wall.length ? maxRight + "px" : "100%";
  field.style.height = wall.length ? (maxBottom + 8) + "px" : "260px";
  field.innerHTML = "";

  wall.forEach((item, i) => {
    const mult = item.variant === "B" ? M().multB : 1;
    const w = base * mult;
    const h = w * M().aspect;
    const img = item.variant === "B" ? item.imgB : item.imgA;
    const label = item.variant === "B" ? item.titleB : item.titleA;
    const hex = document.createElement("div");
    hex.className = "wb-tile" + (item.free ? " wb-is-free" : "");
    hex.style.left = item.x + "px";
    hex.style.top = item.y + "px";
    hex.style.width = w + "px";
    hex.style.height = h + "px";
    hex.dataset.index = i;
    const shapeClass = item.shape === "hex" ? "wb-shape-hex" : "wb-shape-rect";
    hex.innerHTML = `
      <div class="wb-badge">${T().gratisBadge}</div>
      <img class="wb-shape ${shapeClass}" src="${img}" alt="">
      <div class="wb-variant-badge">${(label || "?").charAt(0).toUpperCase()}</div>
      <div class="wb-remove">×</div>
    `;

    const removeBtn = hex.querySelector(".wb-remove");
    removeBtn.addEventListener("pointerdown", e => e.stopPropagation());
    removeBtn.addEventListener("click", e => { e.stopPropagation(); removeFromWall(i); });

    const varBtn = hex.querySelector(".wb-variant-badge");
    varBtn.addEventListener("pointerdown", e => e.stopPropagation());
    varBtn.addEventListener("click", e => { e.stopPropagation(); toggleItemVariant(i); });

    hex.addEventListener("pointerdown", (e) => startDrag(e, hex, item));

    field.appendChild(hex);
  });
}

function startDrag(e, hex, item){
  hex.setPointerCapture(e.pointerId);
  hex.classList.add("wb-dragging");
  hex.style.zIndex = 40;
  const fieldRect = document.getElementById("wbHexField").getBoundingClientRect();
  const hexRect = hex.getBoundingClientRect();
  const grabOffX = e.clientX - hexRect.left;
  const grabOffY = e.clientY - hexRect.top;
  let moved = false;

  function onMove(ev){
    moved = true;
    const x = Math.max(0, ev.clientX - fieldRect.left - grabOffX);
    const y = Math.max(0, ev.clientY - fieldRect.top - grabOffY);
    hex.style.left = x + "px";
    hex.style.top = y + "px";
  }
  function onUp(ev){
    hex.releasePointerCapture(ev.pointerId);
    hex.classList.remove("wb-dragging");
    hex.removeEventListener("pointermove", onMove);
    hex.removeEventListener("pointerup", onUp);
    if(moved){
      item.x = Math.max(0, ev.clientX - fieldRect.left - grabOffX);
      item.y = Math.max(0, ev.clientY - fieldRect.top - grabOffY);
    }
    render();
  }
  hex.addEventListener("pointermove", onMove);
  hex.addEventListener("pointerup", onUp);
}

function renderTiers(){
  const paidCount = bundleEligiblePaidCount();
  const heading = document.getElementById("wbTiersHeading");
  if(heading) heading.textContent = currentMode === "framed" ? T().bundleHeadingFramed : T().bundleHeadingHexagon;
  const row = document.getElementById("wbTiersRow");
  row.innerHTML = "";
  row.style.gridTemplateColumns = `repeat(${Math.min(3, M().tiers.length)}, 1fr)`;
  M().tiers.forEach(tier => {
    const reached = paidCount >= tier.paid;
    const isNext = !reached && nextTierOf(paidCount) === tier;
    const chip = document.createElement("div");
    chip.className = "wb-tier-chip" + (reached ? " wb-reached" : "") + (isNext ? " wb-next" : "");
    chip.innerHTML = `<div class="wb-tier-n">${T().tierBuy(tier.paid)}</div><div class="wb-tier-f">${T().tierGet(tier.free)}</div>`;
    row.appendChild(chip);
  });
}

function renderSummary(){
  const paidItems = wall.filter(w=>!w.free);
  const freeItems = wall.filter(w=>w.free);
  const priceOf = i => i.variant === "B" ? i.priceB : i.priceA;
  const subtotal = paidItems.reduce((s,i) => s + priceOf(i), 0);
  const saved = freeItems.reduce((s,i) => s + priceOf(i), 0);

  document.getElementById("wbPaidCount").textContent = paidItems.length;
  document.getElementById("wbFreeCount").textContent = freeItems.length;
  document.getElementById("wbOriginalAmt").textContent = fmtMoney(subtotal + saved);
  document.getElementById("wbSaveAmt").textContent = fmtMoney(saved);
  document.getElementById("wbTotalAmt").textContent = fmtMoney(subtotal);
  document.getElementById("wbWallTitle").textContent = T().wallTitle(wall.length);
  renderShipBar(subtotal);

  const bundlePaidCount = bundleEligiblePaidCount();
  const nt = nextTierOf(bundlePaidCount);
  const box = document.getElementById("wbNextTierBox");
  const tiers = M().tiers;
  box.innerHTML = nt ? T().nextTier(nt.paid - bundlePaidCount, nt.free) : T().maxTier(tiers[tiers.length-1].free);

  const freeRemaining = Math.max(0, targetFreeFor(bundlePaidCount) - freeItems.length);
  const banner = document.getElementById("wbFreeBanner");
  if(freeRemaining > 0){
    banner.classList.add("wb-show");
    document.getElementById("wbFreeBannerTitle").textContent = T().freeBannerTitle(freeRemaining);
    document.getElementById("wbFreeBannerText").textContent = T().freeBannerText(freeRemaining);
  } else {
    banner.classList.remove("wb-show");
  }
}

function renderShipBar(subtotal){
  const bar = document.getElementById("wbShipBar");
  if(!bar) return;
  const threshold = FREE_SHIPPING_THRESHOLDS[currencyCode()];
  if(!threshold){
    bar.style.display = "none";
    return;
  }
  bar.style.display = "block";
  const pct = Math.max(0, Math.min(100, (subtotal / threshold) * 100));
  document.getElementById("wbShipFill").style.width = pct + "%";
  const text = document.getElementById("wbShipText");
  if(subtotal >= threshold){
    bar.classList.add("wb-ship-done");
    text.innerHTML = T().freeShipUnlocked;
  } else {
    bar.classList.remove("wb-ship-done");
    text.innerHTML = T().freeShipProgress(fmtMoney(threshold - subtotal));
  }
}

function fmtMoney(n){
  const currency = window.WB_CURRENCY_SYMBOL || "€";
  return currency + n.toFixed(2).replace(/\.00$/, "");
}

function render(){
  enforceFreeCap();
  renderWall();
  renderTiers();
  renderSummary();
  renderCatalog();
}

async function handleAddToCart(){
  if(wall.length === 0){ showToast(T().toastEmptyCart); return; }
  const btn = document.getElementById("wbAddToCart");
  const items = wall.map(item => ({
    id: item.variant === "B" ? item.idB : item.idA,
    quantity: 1
  })).filter(i => i.id);

  btn.disabled = true;
  btn.textContent = T().ctaBusy;
  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items })
    });
    if(!res.ok) throw new Error("cart add failed");
    window.location.href = "/cart";
  } catch(e){
    console.error("Wall Builder: cart add failed", e);
    showToast(T().toastCartError);
    btn.disabled = false;
    btn.textContent = T().ctaBtn;
  }
}

function init(){
  document.getElementById("wbSearch").addEventListener("input", renderCatalog);
  document.getElementById("wbClearWall").addEventListener("click", () => { wall = []; colHeights = []; render(); });
  document.getElementById("wbDefA").parentElement.addEventListener("click", (e) => {
    const btn = e.target.closest("button");
    if(!btn) return;
    if(btn.id === "wbDefA"){ defaultVariant = "A"; document.getElementById("wbDefA").classList.add("wb-active"); document.getElementById("wbDefB").classList.remove("wb-active"); renderCatalog(); }
    if(btn.id === "wbDefB"){ defaultVariant = "B"; document.getElementById("wbDefB").classList.add("wb-active"); document.getElementById("wbDefA").classList.remove("wb-active"); renderCatalog(); }
  });
  document.getElementById("wbModeHex").addEventListener("click", () => switchMode("hexagon"));
  document.getElementById("wbModeFramed").addEventListener("click", () => switchMode("framed"));
  document.getElementById("wbAddToCart").addEventListener("click", handleAddToCart);

  const frameTypeRow = document.getElementById("wbFrameTypeRow");
  if(frameTypeRow){
    frameTypeRow.querySelector(".wb-size-toggle").addEventListener("click", (e) => {
      const btn = e.target.closest("button");
      if(!btn) return;
      const newType = btn.id === "wbFramePremium" ? "premium" : "standard";
      if(newType === frameType) return;
      frameType = newType;
      document.getElementById("wbFrameStandard").classList.toggle("wb-active", frameType === "standard");
      document.getElementById("wbFramePremium").classList.toggle("wb-active", frameType === "premium");
      remapCatalog();
    });
  }

  const cardTypeRow = document.getElementById("wbCardTypeRow");
  if(cardTypeRow){
    cardTypeRow.querySelector(".wb-size-toggle").addEventListener("click", (e) => {
      const btn = e.target.closest("button");
      if(!btn) return;
      const newType = btn.id === "wbCardMulti" ? "multi" : "single";
      if(newType === cardType) return;
      cardType = newType;
      document.getElementById("wbCardSingle").classList.toggle("wb-active", cardType === "single");
      document.getElementById("wbCardMulti").classList.toggle("wb-active", cardType === "multi");
      renderFrameTypeUI();
      renderCatalog();
    });
  }

  const tagBtn = document.getElementById("wbTagFilterBtn");
  const tagPanel = document.getElementById("wbTagFilterPanel");
  const tagSearch = document.getElementById("wbTagFilterSearch");
  const tagClearBtn = document.getElementById("wbTagFilterClearBtn");
  if(tagBtn && tagPanel){
    tagBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      tagPanel.classList.toggle("wb-show");
      if(tagPanel.classList.contains("wb-show") && tagSearch) tagSearch.focus();
    });
    tagPanel.addEventListener("click", (e) => e.stopPropagation());
    document.addEventListener("click", (e) => {
      if(!tagPanel.contains(e.target) && e.target !== tagBtn){
        tagPanel.classList.remove("wb-show");
      }
    });
  }
  if(tagSearch){
    tagSearch.addEventListener("input", (e) => {
      tagFilterSearch = e.target.value;
      renderTagFilter();
    });
  }
  if(tagClearBtn){
    tagClearBtn.addEventListener("click", () => {
      activeTags.clear();
      tagFilterSearch = "";
      if(tagSearch) tagSearch.value = "";
      renderTagFilter();
      renderCatalog();
    });
  }

  const langSwitch = document.getElementById("wbLangSwitch");
  if(langSwitch){
    langSwitch.value = currentLang;
    langSwitch.addEventListener("change", (e) => {
      currentLang = e.target.value;
      applyStaticLang();
      render();
    });
  }

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(renderWall, 120);
  });

  applyStaticLang();
  render();
  fetchCatalog();
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
})();
